export * from "./validators";

/**
 * JSON.parse를 안전하게 실행합니다. 파싱 실패 시 fallback을 반환합니다.
 * @template T
 * @param {string|null} str - 파싱할 JSON 문자열
 * @param {T} [fallback=null] - 파싱 실패 시 반환할 기본값
 * @returns {T}
 */
export function safeJsonParse(str, fallback = null) {
  try {
    return str ? JSON.parse(str) : fallback;
  } catch {
    return fallback;
  }
}
